module.exports = {
      id: "comm-gadgets-usage",
      viewBox: "0 0 320 56.865",
      url: "/" + "sprite-ab56b996b385d9abaaf31e01c38c81cd.svg#comm-gadgets",
      toString: function () {
        return this.url;
      }
    }